import PropTypes from 'prop-types';
import { useContext } from 'react';
import { PriceContext } from '../contexts/PriceContext';
import { UserContext } from '../contexts/UserContext';
import { usePackages } from '../hooks/usePackages';
import Package from './Package';
import Radio from './ui/Radio';

export default function Packages({ generalData, getLabel, config, packages, paymentInterval, updatePackages }) {
	const { userData, currency, locale } = useContext(UserContext);
	const { useDecimalPlaces } = useContext(PriceContext);
	const { availablePackages, addPackage, removePackage, resetPackages } = usePackages({
		config,
		packages,
		paymentInterval,
		currency,
		locale,
		updatePackages,
		userData,
		useDecimalPlaces,
	});
	const showEmptyOption = !config.allow_multiple_selection && !config.package_required;

	return (
		<>
			<div className="prc-package-header">
				<div className="prc-package-header__content">
					<h4 className="prc-package-header__title">{getLabel('packages_header_heading')}</h4>
					<p className="prc-package-header__text" dangerouslySetInnerHTML={{ __html: getLabel('packages_header_text') }} />
				</div>
				{generalData?.packages?.header_image && (
					<div className="prc-package-header__image">
						<img src={generalData.packages.header_image.full_url} />
					</div>
				)}
			</div>
			<ul className="prc-packages">
				{showEmptyOption && (
					<li className="prc-package">
						<div className="prc-package__tab">
							<div className="prc-package__name" data-testid="prc-package-tab-name">
								{getLabel('package_empty_option')}
							</div>
							<div className="prc-package__action">
								<Radio name="package" value={'0'} callback={resetPackages} checked={!userData.packages.length} testId="prc-package-input" />
							</div>
						</div>
					</li>
				)}
				{Object.entries(availablePackages).map(([id, data]) => {
					const isSelected = userData.packages.includes(parseInt(id));
					return (
						<Package
							key={id}
							id={parseInt(id)}
							allowMultiple={config.allow_multiple_selection}
							data={data}
							getLabel={getLabel}
							addPackage={addPackage}
							removePackage={removePackage}
							selected={isSelected}
							paymentInterval={paymentInterval}
						/>
					);
				})}
			</ul>
		</>
	);
}

Packages.propTypes = {
	config: PropTypes.object.isRequired,
	generalData: PropTypes.object.isRequired,
	getLabel: PropTypes.func.isRequired,
	packages: PropTypes.array.isRequired,
	paymentInterval: PropTypes.string.isRequired,
	updatePackages: PropTypes.func.isRequired,
};
